export function getProcessArgValue(argName: string): string{
    const procArg  = process.argv.map(e=>e.split('=')).filter(z=>z.length === 2).find(f=>f[0] === argName);
    return procArg ? procArg[1] : null;
}
